import React, {Component} from 'react';

import plusPNG from '../../static/img/new/plus.png';

class AddFilter extends Component {
    render() {
        let disabledClass = this.props.disabled ? 'disabled' : '';
        return (
            <div className={"clearfix add_filter " + disabledClass}>
                <p>
                    <img src={plusPNG} alt=""/>
                    Добавить фильтр
                </p>

                <div className="grid grid-width-1-2 mt30">
                    <div>
                        <label>
                            <input className="gray nomargin" type="text" name="name"
                                   placeholder="Название" disabled={this.props.disabled}/>
                        </label>
                    </div>
                    <div>
                        <label className="file_label">
                            Загрузите иконку
                            <input type="file" name="file" disabled={this.props.disabled}/>
                        </label>
                    </div>
                </div>
            </div>
        )
    }
}

export default AddFilter;



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/AddFilter.js